import { ChatSocketRepository } from "../repositories/ChatSocketRepository";

export class ConnectSocketChat {
	constructor(private repository: ChatSocketRepository) {}
	execute(): Promise<void> {
		return this.repository.connectSocket();
	}
}
